import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../axios";

// ПОЧЕМУ ЗДЕСЬ НЕТ ЗАПАСНЫХ ДАННЫХ.
// Раньше при недоступном API сюда подставлялся список из src/sample/data.js —
// выдуманные туры «Mountain Hiking, $120» с несуществующими картинками.
// Человек видел не сбой, а прайс: тур, которого нет, по цене, которой нет.
// Один неверный CORS_ORIGINS на бою — и сайт торгует несуществующим товаром.
// Теперь при ошибке список пустой, а секции показывают честное «туров нет».

export const fetchActivities = createAsyncThunk('activities/fetchActivities', async () => {
    try {
        const { data } = await axios.get('/activities');
        return data;
    } catch (error) {
        console.error("Не удалось загрузить туры с сервера.", error);
        return [];
    }
});

export const fetchActivityById = createAsyncThunk('activities/fetchActivityById', async (id) => {
    try {
        const { data } = await axios.get(`/activities/${id}`);
        return data;
    } catch (error) {
        console.error("Не удалось загрузить тур с сервера.", error);
        return null;
    }
});

export const fetchRemoveActivities = createAsyncThunk('activities/fetchRemoveActivities', async (id) => {
    axios.delete(`/activities/${id}`);
});

const initialState = {
    activities: {
        items: [],
        status: 'loading',
    },
    selectedActivity: {
        item: null,
        status: 'idle',
    },
};

const activitiesSlice = createSlice({
    name: 'activities',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchActivities
            .addCase(fetchActivities.pending, (state) => {
                state.activities.items = [];
                state.activities.status = 'loading';
            })
            .addCase(fetchActivities.fulfilled, (state, action) => {
                state.activities.items = action.payload;
                state.activities.status = 'loaded';
            })
            .addCase(fetchActivities.rejected, (state) => {
                state.activities.items = [];
                state.activities.status = 'error';
            })
            // Handle fetchActivityById
            .addCase(fetchActivityById.pending, (state) => {
                state.selectedActivity.item = null;
                state.selectedActivity.status = 'loading';
            })
            .addCase(fetchActivityById.fulfilled, (state, action) => {
                state.selectedActivity.item = action.payload;
                state.selectedActivity.status = 'loaded';
            })
            .addCase(fetchActivityById.rejected, (state) => {
                state.selectedActivity.item = null;
                state.selectedActivity.status = 'error';
            })
            // Handle fetchRemoveActivities
            .addCase(fetchRemoveActivities.pending, (state, action) => {
                state.activities.items = state.activities.items.filter(obj => obj._id !== action.meta.arg);
            });
    }
});

export const activitiesReducer = activitiesSlice.reducer;